export default __webpack_public_path__ + "static/media/dimension_sedan.ca7f9014.jpg";